var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomCompass = function SvgCustomCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 10.494c-.04-1.094-.018-2.24.011-3.065.729.387 1.732.941 2.66 1.523.55.345 1.06.693 1.466 1.015.427.338.664.592.75.741.086.15.187.482.267 1.02.076.513.122 1.129.146 1.778.04 1.094.018 2.24-.011 3.064a44.193 44.193 0 0 1-2.66-1.523c-.55-.345-1.06-.692-1.466-1.014-.426-.339-.664-.592-.75-.742-.086-.149-.187-.482-.267-1.02a16.859 16.859 0 0 1-.145-1.777Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

export default SvgCustomCompass;